import { Component, ElementRef, AfterViewInit, Input } from '@angular/core';

@Component({
  selector: 'app-test-stocks-twc',
  templateUrl: './test-stocks-twc.component.html',
  styleUrls: ['./test-stocks-twc.component.scss'],
})
export class TestStocksTWCComponent implements AfterViewInit {
  @Input() symbol: string = 'NSE:HDFCBANK'; // Default to HDFC Bank on NSE
  @Input() height: number = 500;
  @Input() width: string = '100%';

  constructor(private elementRef: ElementRef) {}

  ngAfterViewInit(): void {
    this.loadTradingViewScript();
  }

  loadTradingViewScript(): void {
    if (document.getElementById('tradingview-script')) {
      this.renderWidget();
      return;
    }

    const script = document.createElement('script');
    script.id = 'tradingview-script';
    script.type = 'text/javascript';
    script.src = 'https://s3.tradingview.com/tv.js';
    script.onload = () => this.renderWidget();
    document.body.appendChild(script);
  }

  renderWidget(): void {
    if (typeof (window as any).TradingView !== 'undefined') {
      new (window as any).TradingView.widget({
        container_id: 'tradingview-widget',
        width: this.width,
        height: this.height,
        symbol: this.symbol,
        interval: 'D',
        timezone: 'Etc/UTC',
        theme: 'light',
        style: '1',
        locale: 'en',
        toolbar_bg: '#f1f3f6',
        enable_publishing: false,
        hide_top_toolbar: false,
        hide_side_toolbar: false,
        allow_symbol_change: true,
      });
    }
  }
}
